import React, { useState } from 'react';
import { Loader2, Send, Trash2, Pencil, X } from 'lucide-react';
import { Button } from '../ui/button';
import { fittingAPI } from '../../services/api';
import { useT } from '../../services/i18n';

// Centre self-service: reply / edit / delete its public answer to a customer review
const CentreReplyBox = ({ token, review, onChanged }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(review.reply?.message || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async () => {
    setBusy(true); setError('');
    try { await fittingAPI.centreReply(token, review.id, text.trim()); setOpen(false); onChanged(); } catch (e) { setError(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || t('ps.sendFailed')); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm(t('ps.deleteReplyConfirm'))) return;
    setBusy(true);
    try { await fittingAPI.centreDeleteReply(token, review.id); setText(''); onChanged(); } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <div className="mt-1.5 ml-3 flex gap-2 text-xs">
        <button type="button" onClick={() => setOpen(true)} className="text-orange-600 hover:text-orange-700 inline-flex items-center gap-1 font-medium" data-testid={`reply-open-${review.id}`}>{review.reply ? <><Pencil size={11} /> {t('ps.editReply')}</> : <><Send size={11} /> {t('ps.reply')}</>}</button>
        {review.reply && <button type="button" onClick={remove} disabled={busy} className="text-gray-400 hover:text-red-600 inline-flex items-center gap-1" data-testid={`reply-delete-${review.id}`}><Trash2 size={11} /> {t('nc.delete')}</button>}
      </div>
    );
  }
  return (
    <div className="mt-2 ml-3 rounded-lg border border-orange-200 bg-orange-50/40 p-2" data-testid={`reply-form-${review.id}`}>
      <textarea value={text} onChange={(e) => setText(e.target.value.slice(0, 1000))} rows={3} placeholder={t('ps.replyPlaceholder')} className="w-full rounded-md border border-gray-300 p-2 text-sm bg-white" data-testid={`reply-text-${review.id}`} />
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[11px] text-gray-400">{text.length}/1000 · {t('ps.publicReply')}{!review.reply ? `, ${t('ps.customerNotified')}` : ''}</span>
        <div className="flex gap-1">
          <button type="button" onClick={() => setOpen(false)} className="p-1.5 text-gray-400 hover:text-gray-700" data-testid={`reply-cancel-${review.id}`}><X size={14} /></button>
          <Button size="sm" onClick={save} disabled={busy || text.trim().length < 2} className="bg-orange-500 hover:bg-orange-600 h-7 text-xs" data-testid={`reply-save-${review.id}`}>{busy ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} className="mr-1" />} {t('ps.publish')}</Button>
        </div>
      </div>
      {error && <p className="text-xs text-red-600 mt-1" data-testid={`reply-error-${review.id}`}>{String(error)}</p>}
    </div>
  );
};

export default CentreReplyBox;
